// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionCollection
import { getAPIURL } from "assessments/utils"

export default QuestionCollection = (function () {
  QuestionCollection = class QuestionCollection extends (
    require("lib/static-shim").default(Backbone.Collection)
  ) {
    static initClass() {
      this.prototype.model = require("./question").default
    }

    url() {
      let url = `${this.assessment.id}/question`
      url = getAPIURL(url, this)
      return url
    }

    initialize(models, options) {
      if (options == null) {
        options = {}
      }
      this.options = options
      _.defaults(this.options, { isAdmin: false })
      return ({ assessment: this.assessment } = this.options)
    }

    nextOrder() {
      if (!this.length) {
        return 1
      }
      return this.last().get("order") + 1
    }

    comparator(item) {
      let sort = item.get("order")
      if (!this.options.isAdmin) {
        if (this.assessment.get("randomize_question_order")) {
          sort = Math.ceil(Math.random() * (100 - 1))
        }
      }
      return sort
    }
  }
  QuestionCollection.initClass()
  return QuestionCollection
})()
